export const disconnectUser = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiration");
    localStorage.removeItem("noCreditClient");
    localStorage.removeItem("noCreditProspect");
    window.location.replace(process.env.REACT_APP_URL +`/users/sign_in`);
};

